import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { ENUM__connection_state } from '@/enums/ENUM__connection_state';
import { local_app_info_upsert } from '@/state/app_info/local_app_info_upsert';
import { local_collection_special_info_upsert } from '@/state/collection/special/local_collection_special_info_upsert';
import { local_ml_asset_reservations_delete } from '@/state/diffusion_models_ud/local_ml_asset_reservations_delete';
import { local_ml_asset_reservations_upsert } from '@/state/diffusion_models_ud/local_ml_asset_reservations_upsert';
import { local_ml_asset_upsert_model } from '@/state/diffusion_models_ud/local_ml_asset_upsert_model';
import { local_ml_asset_upsert_table_page } from '@/state/diffusion_models_ud/local_ml_asset_upsert_table_page';
import { local_ml_asset_upsert_table_without_pages } from '@/state/diffusion_models_ud/local_ml_asset_upsert_table_without_pages';
import { local_grid2d_update_partial } from '@/state/grid2d/grid2d/local_grid2d_update_partial';
import { local_images_upsert_ai_description } from '@/state/images/local_images_upsert_ai_description';
import { local_network_set_state } from '@/state/network/local_network_set_state';
import { store } from '@/state/store';
import { local_user_settings_upsert } from '@/state/user/settings/local_user_settings_upsert';
import { local_user_tutorial_progress_upsert } from '@/state/user/tutorial/local_user_tutorial_progress_upsert';
import { on_workspace_child_entity_delete_collection } from '@/state/workspace/_methods/on_workspace_child_entity_delete_collection';
import { on_workspace_child_entity_delete_search } from '@/state/workspace/_methods/on_workspace_child_entity_delete_search';
import { on_workspace_child_entity_delete_user_task } from '@/state/workspace/_methods/on_workspace_child_entity_delete_user_task';
import { DTOImageAiDescription } from '@shared/dto/+image/image_ai_description/dto_image_ai_description';
import { DTO__ml_asset_reservation } from '@shared/dto/+model/reservation/DTO__ml_asset_reservation';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { DTODiffusionModelsTablePageUD } from '@shared/dto/+model/table/dto_diffusion_models_table_page_ud';
import { DTODiffusionModelsTableUD } from '@shared/dto/+model/table/dto_diffusion_models_table_ud';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { DTOUserTutorialProgress } from '@shared/dto/+user/user_tutorial/dto_tutorial_progress';
import { DTO__app_info } from '@shared/dto/app_info/DTO__app_info';
import { ResponseCollectionSpecialInfo } from '@shared/dto/collection/_requests/response_collection_images_ids_in_special_collections';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { ENetworkEventClientOnly } from '@shared/network/ENetworkEventClientOnly';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { log_connection_terms_user, loge } from '@shared/utils/utils_logs';
import { Socket } from 'socket.io-client';
import { add_socket_handlers_client_admin } from '../_handlers_registrations/add_socket_handlers_client_admin';
import { add_socket_handlers_client_generation } from '../_handlers_registrations/add_socket_handlers_client_generation';
import { add_socket_handlers_client_generation_price } from '../_handlers_registrations/add_socket_handlers_client_generation_price';
import { add_socket_handlers_client_words } from '../_handlers_registrations/add_socket_handlers_client_words';
import { HANDLER_CLIENT__collection_upsert } from '../_handlers_registrations/collection/HANDLER_CLIENT__collection_upsert';
import { HANDLER_CLIENT__grid2d_cells_delete } from '../_handlers_registrations/grid2d/HANDLER_CLIENT__grid2d_cells_delete';
import { HANDLER_CLIENT__grid2d_cells_upsert } from '../_handlers_registrations/grid2d/HANDLER_CLIENT__grid2d_cells_upsert';
import { HANDLER_CLIENT__grid2d_chunk_update_without_cells } from '../_handlers_registrations/grid2d/HANDLER_CLIENT__grid2d_chunk_update_without_cells';
import { HANDLER_CLIENT__grid2d_chunk_upsert } from '../_handlers_registrations/grid2d/HANDLER_CLIENT__grid2d_chunk_upsert';
import { HANDLER_CLIENT__grid2d_upsert } from '../_handlers_registrations/grid2d/HANDLER_CLIENT__grid2d_upsert';
import { HANDLER_CLIENT__image_meta_upsert } from '../_handlers_registrations/image/HANDLER_CLIENT__image_meta_upsert';
import { HANDLER_CLIENT__image_upsert } from '../_handlers_registrations/image/HANDLER_CLIENT__image_upsert';
import { HANDLER_SEARCH__upsert } from '../_handlers_registrations/search/HANDLER_SEARCH__upsert';
import { HANDLER_CLIENT__user_auth_failed } from '../_handlers_registrations/user/HANDLER_CLIENT__user_auth_failed';
import { HANDLER_CLIENT__user_task_upsert } from '../_handlers_registrations/user_task/HANDLER_CLIENT__user_task_upsert';
import { HANDLER_CLIENT__user_task_upsert_without_generations } from '../_handlers_registrations/user_task/HANDLER_CLIENT__user_task_upsert_without_generations';
import { add_socket_handlers_client_workspace } from '../_handlers_registrations/workspace/add_socket_handlers_client_workspace';
import { add_socket_handlers_client_workspace_billing } from '../_handlers_registrations/workspace/add_socket_handlers_client_workspace_billing';
import { add_socket_handlers_client_workspace_child_entity } from '../_handlers_registrations/workspace/add_socket_handlers_client_workspace_child_entity';
import { add_socket_handlers_client_workspace_ownership_proposal } from '../_handlers_registrations/workspace/add_socket_handlers_client_workspace_ownership_proposal';
import { add_socket_handlers_client_workspace_user } from '../_handlers_registrations/workspace/add_socket_handlers_client_workspace_user';
import { add_socket_handler_client as add } from '../_methods/add_socket_handler_client';
import { service_socketio_client } from '../service_socketio_client';
import { add_socket_handler_client } from './add_socket_handler_client';
import { on_received_pong } from './on_received_pong';
import { try_log_server_to_client } from './try_log_in_client';

export function add_socket_handlers_client_all(socket: Socket) {
  let logger_params = { namespace: ELoggerNamespaceShared.SERVER_TO_CLIENT };

  /*
   * BASE
   */
  socket.on(ENetworkEventClientOnly.ERROR, () => {
    debugger;
  });

  socket.on(ENetworkEventClientOnly.CONNECT, () => {
    CONSTANTS__client.LOGGER_CONNECTION_ID = socket.id || '';

    store.dispatch(local_network_set_state(ENUM__connection_state.CONNECTION_ESTABLISHED));

    log_connection_terms_user(CONSTANTS__client.LOGGER_CONNECTION_ID, ELoggerNamespaceShared.CLIENT_TO_SERVER);
  });

  add_socket_handler_client(ENE.PONG, on_received_pong);

  //FYI: this method doesnt work after using msgPack client <--> server
  socket.on(ENE.DISCONNECT, reason => {
    if (CONSTANTS__client.SERVICE_SOCKETIO_LOGGER_ENABLED) loge('socket disconnected', logger_params);

    store.dispatch(local_network_set_state(ENUM__connection_state.DISCONNECTED));
    service_socketio_client.is_connection_authorized = false;
  });

  socket.onAny((event: string, ...args: any[]) => {
    if (service_socketio_client.events_map.has(event)) return;

    loge(`unhandled event: ${event} with data:\n${JSON.stringify(args)}`, logger_params);
  });

  socket.on(ENetworkEventClientOnly.CONNECT_ERROR, error => {
    if (CONSTANTS__client.SERVICE_SOCKETIO_LOGGER_ENABLED) loge('socket connection error', { ...logger_params, omit_stack_trace: true });

    store.dispatch(local_network_set_state(ENUM__connection_state.CONNECTION_ERROR));
    service_socketio_client.is_connection_authorized = false;
  });

  socket.on('reconnect', () => {
    if (CONSTANTS__client.SERVICE_SOCKETIO_LOGGER_ENABLED) loge('socket reconnected', logger_params);

    store.dispatch(local_network_set_state(ENUM__connection_state.CONNECTION_ESTABLISHED));
  });

  socket.on(ENE.RESPONSE_ERROR, (error: string) => {
    try_log_server_to_client(ENE.RESPONSE_ERROR, new Uint8Array());

    loge(error, logger_params);
    debugger;
  });

  add_socket_handlers_client_admin();

  add(ENE.APP_INFO_UPSERT, (item: DTO__app_info) => store.dispatch(local_app_info_upsert(item)));

  /*
   * COLLECTION
   */

  add(ENE.COLLECTION_UPSERT, HANDLER_CLIENT__collection_upsert);
  add(ENE.COLLECTION_DELETE, (ids: string[]) => on_workspace_child_entity_delete_collection(ids));
  add(ENE.COLLECTION_SPECIAL_INFO_UPSERT, (items: ResponseCollectionSpecialInfo[]) => store.dispatch(local_collection_special_info_upsert(items)));

  /*
   * GRID2D
   */
  add(ENE.GRID2D_UPSERT, HANDLER_CLIENT__grid2d_upsert);
  add(ENE.GRID2D_UPDATE_PARTIAL, (items: Partial<DTO__grid2d>[]) => store.dispatch(local_grid2d_update_partial(items)));
  add(ENE.GRID2D_CHUNK_UPSERT, HANDLER_CLIENT__grid2d_chunk_upsert);
  add(ENE.GRID2D_CHUNK_UPDATE_WITHOUT_CELLS, HANDLER_CLIENT__grid2d_chunk_update_without_cells);

  /*
   * ML ASSET
   */

  let dispatch = store.dispatch;

  add(ENE.ML_ASSET_UPSERT, (items: DTO__ml_asset[]) => dispatch(local_ml_asset_upsert_model(items)));

  add(ENE.ML_ASSET_RESERVATION_UPSERT, (items: DTO__ml_asset_reservation[]) => dispatch(local_ml_asset_reservations_upsert(items)));
  add(ENE.ML_ASSET_RESERVATION_DELETE, (items: string[]) => dispatch(local_ml_asset_reservations_delete(items)));
  add(ENE.ML_ASSET_TABLE_UPSERT_WITHOUT_PAGES, (items: DTODiffusionModelsTableUD[]) => dispatch(local_ml_asset_upsert_table_without_pages(items)));
  add(ENE.ML_ASSET_TABLE_PAGE_UPSERT, (items: DTODiffusionModelsTablePageUD[]) => dispatch(local_ml_asset_upsert_table_page(items)));

  /*
   *
   */
  add_socket_handlers_client_generation();
  add_socket_handlers_client_generation_price();
  /*
   *
   */
  add(ENE.USER_TASK_UPSERT, HANDLER_CLIENT__user_task_upsert);
  add(ENE.USER_TASK_UPDATE_WITHOUT_GENERATIONS, HANDLER_CLIENT__user_task_upsert_without_generations);
  add(ENE.USER_TASK_DELETE, (ids: string[]) => on_workspace_child_entity_delete_user_task(ids));

  /*
   * SEARCH
   */
  add(ENE.SEARCH_UPSERT, HANDLER_SEARCH__upsert);
  add(ENE.SEARCH_DELETE, (ids: string[]) => on_workspace_child_entity_delete_search(ids));

  add_socket_handlers_client_words();

  add(ENE.IMAGE_AI_DESCRIPTION_UPSERT, (items: DTOImageAiDescription[]) => store.dispatch(local_images_upsert_ai_description(items)));

  /*
   * IMAGE
   */
  add(ENE.IMAGE_UPSERT, HANDLER_CLIENT__image_upsert);

  add(ENE.IMAGE_META_UPSERT, HANDLER_CLIENT__image_meta_upsert);

  /*
   * GRID2D
   */

  add(ENE.GRID2D_CELLS_UPSERT, HANDLER_CLIENT__grid2d_cells_upsert);
  add(ENE.GRID2D_CELLS_DELETE, HANDLER_CLIENT__grid2d_cells_delete);

  add_socket_handlers_client_workspace();
  add_socket_handlers_client_workspace_billing();
  add_socket_handlers_client_workspace_child_entity();
  add_socket_handlers_client_workspace_ownership_proposal();
  add_socket_handlers_client_workspace_user();

  /*
   *
   */
  add(ENE.USER_AUTH_FAILED, HANDLER_CLIENT__user_auth_failed);
  add(ENE.USER_SETTINGS_UPSERT, (dto: DTO__user_settings) => dispatch(local_user_settings_upsert(dto)));
  add(ENE.USER_TUTORIAL_PROGRESS_UPSERT, (dto: DTOUserTutorialProgress) => dispatch(local_user_tutorial_progress_upsert(dto)));
}
